/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const Share = createSvgIcon(
    <path
        d="M24.466 14.207l-6.764-6.764C17.408 7.15 17.107 7 16.809 7c-.414 0-.898.31-.898 1.185v4.17a8.442 8.442 0 00-5.453 2.501A8.447 8.447 0 008 20.834c0 .971.163 1.925.484 2.834a.498.498 0 00.94 0 7.532 7.532 0 016.487-4.98v4.127c0 .874.484 1.185.898 1.185.299 0 .599-.15.893-.443l6.764-6.764c.344-.345.534-.804.534-1.293 0-.49-.19-.948-.534-1.293z"
        fill="#FE000C"
    />,
    "Share",
);

export default Share;
